export default "__VITE_ASSET__B2j4rgUi__"